import { Text } from "@ui/components/content/text/Text";
import { Button } from "@ui/components/forms/button/Button";
import { Box } from "@ui/components/layout/box/Box";
import { Flex } from "@ui/components/layout/flex/Flex";
import { ECCOIcon } from "@ui/components/media-and-icons/ecco-icon/ECCOIcon";
import { styles } from "./Warning.style";

type Props = {
    onClose: () => void;
    onConfirm: () => void;
    headers: {
        title: string;
        description: string;
        confirm: string;
        close: string;
    };
};

export const Warning = ({ onClose, onConfirm, headers }: Props) => {
    const { description, title, close, confirm } = headers;
    return (
        <Box {...styles.box}>
            <Flex {...styles.wrapper}>
                <ECCOIcon size="2xl" name="info" />
                <Text {...styles.title}>{title}</Text>
                <Text maxWidth="sm">{description}</Text>
            </Flex>
            <Flex {...styles.buttonsWrapper}>
                <Button {...styles.button} onClick={onConfirm} size="md" variant="solid">
                    {confirm}
                </Button>
                <Button {...styles.button} onClick={onClose} size="md" variant="standard">
                    {close}
                </Button>
            </Flex>
        </Box>
    );
};
